import React from 'react';
import '../../styles/brokerage.css'; // Import Brokerage specific CSS
import '../../styles/Fonts.css'; // Import Fonts specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

const BrokeragetServices = () => {
  return (
    <>
      {/* Brokerage Services Section */}
      <section id="brokerage-services" className="about-preview-section">
        <div className="container">
          <div className="about-content-wrapper">
            <div className="about-text-content">
              <div className="section-badge">WHAT WE PROVIDE</div>
              <h2 className="section-title">Our Brokerage Services</h2>
              <p className="section-description">
                Our comprehensive brokerage services simplify customs clearance and ensure your 
                shipments navigate international regulations with precision. We handle all documentation 
                and compliance requirements for seamless border crossings.
              </p>
              <p className="section-description">
                From import to export operations, our expert team minimizes delays and avoids 
                costly penalties. We provide complete customs management so you can focus on 
                growing your business without regulatory complexities.
              </p>
              
              <div className="hero-actions mt-4">
                <a href="/contactUs" className="btn-primary-hero">Get Started</a>
              </div>
            </div>
            <div className="about-image-content">
              <div className="about-stats">
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-file-import"></i>
                  </div>
                  <span className="stat-number">Import</span>
                  <div className="stat-label">Customs clearance services</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-file-export"></i>
                  </div>
                  <span className="stat-number">Export</span>
                  <div className="stat-label">Documentation handling</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-balance-scale"></i>
                  </div>
                  <span className="stat-number">Compliance</span>
                  <div className="stat-label">Regulatory expertise</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-users"></i>
                  </div>
                  <span className="stat-number">Consultation</span>
                  <div className="stat-label">Expert advisory services</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BrokeragetServices;
